import { isNotetakerEligibleLocationKind } from './location_kinds'

const getAutoRecordCalendlyEnabled = (miSettings) => {
  if (!miSettings) return true

  if (typeof miSettings.autoRecordV3Calendly === 'boolean') {
    return miSettings.autoRecordV3Calendly
  }

  if (typeof miSettings.autoRecordV2Calendly === 'string') {
    return miSettings.autoRecordV2Calendly !== 'none'
  }

  return true
}

export const isNotetakerEtSaveEligibleForLocationConfigurations = (locationConfigurationsAttributes = [], hasMsTeamsFlag = false) => (
  locationConfigurationsAttributes.some((locationConfiguration) => {
    if (!locationConfiguration || locationConfiguration._destroy) return false

    return isNotetakerEligibleLocationKind(locationConfiguration.kind, hasMsTeamsFlag)
  })
)

const getMiCalendlyIncludeList = (miSettings) => (
  miSettings?.autoRecordV3CalendlyIncludeList
  || miSettings?.autoRecordV2CalendlyIncludeList
  || []
)

const isEventTypeInIncludeList = ({ eventTypeId, includeList }) => {
  const eventTypeIdAsString = String(eventTypeId)
  return includeList.some((id) => String(id) === eventTypeIdAsString)
}

const addEventTypeToIncludeList = ({ eventTypeId, includeList }) => {
  if (isEventTypeInIncludeList({ eventTypeId, includeList })) return includeList
  return [...includeList, eventTypeId]
}

const removeEventTypeFromIncludeList = ({ eventTypeId, includeList }) => {
  const eventTypeIdAsString = String(eventTypeId)
  return includeList.filter((id) => String(id) !== eventTypeIdAsString)
}

export const buildNotetakerEtToggleUpdatePayload = ({
  eventTypeId,
  enabledForEventType,
  miSettings,
}) => {
  if (!eventTypeId || typeof enabledForEventType !== 'boolean') return null

  const includeList = getMiCalendlyIncludeList(miSettings)
  const miEnabled = Boolean(miSettings?.miEnabled)
  const autoRecordCalendlyEnabled = getAutoRecordCalendlyEnabled(miSettings)
  const isEtInIncludeList = isEventTypeInIncludeList({ eventTypeId, includeList })
  const isEtEnabledViaMi = miEnabled && autoRecordCalendlyEnabled && isEtInIncludeList

  if (enabledForEventType === isEtEnabledViaMi) return null

  if (enabledForEventType) {
    // If Calendly auto-recording is currently off, treat ET-level enable from editor
    // as an explicit scope reset to just this ET when turning it back on.
    const nextIncludeList = autoRecordCalendlyEnabled
      ? addEventTypeToIncludeList({ eventTypeId, includeList })
      : [eventTypeId]

    return {
      miEnabled: true,
      autoRecordV3Calendly: true,
      autoRecordV3CalendlyIncludeList: nextIncludeList,
    }
  }

  return {
    autoRecordV3CalendlyIncludeList: removeEventTypeFromIncludeList({ eventTypeId, includeList }),
  }
}
